module.exports = __webpack_public_path__ + "img/xingyongbaogao.84a621b5.png";